import {
  FormControl,
  Grid,
  MenuItem,
  TextField,
  TextFieldProps,
} from '@mui/material';
import { FieldError } from 'react-hook-form';

import { gridSize } from '@/shared/constants';

export type CustomSelectTextFieldProps<T> = {
  label: string;
  required?: boolean;

  textFieldKey?: string;
  register: TextFieldProps;
  error: FieldError | undefined;
  helperText: React.ReactNode;

  options: T[];
  defaultValue: string | number;
  labelKey: keyof T;
  valueKey: keyof T;
  menuItemKey: keyof T;
  isLoading?: boolean;

  size?: {
    xs: number;
    sm: number;
    md: number;
    lg: number;
  };

  disabled?: boolean;
};

function CustomSelectTextField<T>({
  error,
  helperText,
  label,
  options,
  labelKey,
  register,
  textFieldKey,
  valueKey,
  defaultValue,
  size = gridSize,
  menuItemKey,
  required = true,
  disabled = false,
}: // isLoading = false,
  Readonly<CustomSelectTextFieldProps<T>>) {
  return (
    <Grid item {...size}>
      <FormControl fullWidth variant="outlined">
        <TextField
          key={textFieldKey ?? defaultValue}
          select
          label={label}
          variant="outlined"
          fullWidth
          // size="small"
          // margin="none"
          defaultValue={defaultValue}
          {...register}
          error={!!error}
          helperText={helperText}
          required={required}
          disabled={disabled}
        >
          {options.map((item: any) => {
            return (
              <MenuItem key={item[menuItemKey]} value={item[valueKey]}>
                {item[labelKey]}
              </MenuItem>
            );
          })}
        </TextField>
      </FormControl>
    </Grid>
  );
}

export default CustomSelectTextField;
